import React from "react";
import { Phone, FileText, Wrench, Truck } from "lucide-react";
import { processSteps } from "../data/mock";

const stepIcons = [
  Phone,
  FileText,
  Wrench,
  Truck,
];

export const Process = () => {
  return (
    <section id="ablauf" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-accent font-semibold text-sm tracking-wider uppercase mb-4">
            Der Ablauf
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-4">
            So läuft's ab
          </h2>
          <p className="text-lg text-secondary max-w-2xl mx-auto">
            Einfach, transparent und effizient – in vier Schritten zu reparierten Belägen
          </p>
        </div>

        {/* Process Steps */}
        <div className="relative">
          {/* Connection Line - Desktop */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-0.5 bg-gradient-to-r from-primary/20 via-accent/40 to-primary/20" />

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {processSteps.map((step, index) => {
              const IconComponent = stepIcons[index];
              return (
                <div key={step.step} className="relative group">
                  {/* Step Card */}
                  <div className="bg-neutral-light rounded-2xl p-8 h-full transition-all duration-300 hover:shadow-lg hover:bg-white">
                    {/* Step Number & Icon */}
                    <div className="relative mb-6">
                      <div className="w-16 h-16 rounded-2xl bg-primary flex items-center justify-center relative z-10 group-hover:bg-accent transition-colors">
                        {IconComponent && (
                          <IconComponent className="w-7 h-7 text-white" />
                        )}
                      </div>
                      {/* Step number badge */}
                      <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-accent text-neutral-dark font-bold text-sm flex items-center justify-center shadow-md">
                        {step.step}
                      </div>
                    </div>

                    {/* Content */}
                    <h3 className="text-lg font-bold text-primary mb-3">
                      {step.title}
                    </h3>
                    <p className="text-secondary text-sm leading-relaxed">
                      {step.description}
                    </p>
                  </div>

                  {/* Arrow connector - Mobile/Tablet */}
                  {index < processSteps.length - 1 && (
                    <div className="lg:hidden flex justify-center my-4">
                      <div className="w-0.5 h-8 bg-accent/30" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
